import { createListLoader, API } from '@/store/utils/loader';

export default createListLoader({
  namespaced: true,
  config: {
    url: `${API.v3}/allocations.json`,
    module: 'allocations',
  },
});
